import { registerLocale } from "react-datepicker";
import { useIntl } from "react-intl";
import { Navigate, Route, Routes } from "react-router-dom";
import { MasterLayout } from "../modules/common/Masterpage";
import { AgentWrapper } from "../pages/agentlist/AgentListWrapper";
import { CashierSettingWrapper } from "../pages/cashierSetting/CashierSettingWrapper";
import { ChangePasswordWrapper } from "../pages/changePassword/ChangePasswordWrapper";
import { DashbordWrapper } from "../pages/dashboard/DashboardWrapper";
import { MemberWrapper } from "../pages/memberlist/MemberListWrapper";
import { MessageBoxWrapper } from "../pages/messageBox/MessageBoxWrapper";
import { PlatformSettingWrapper } from "../pages/platformSetting/PlatformSettingWrapper";
import { ProjectCreditWrapper } from "../pages/projectcredit/ProjectCreditWrapper";
import { PromotionWrapper } from "../pages/promotion/promotionWrapper";
import { RefundNPromotionWrapper } from "../pages/refundNPromotion/RefundNPromotionWrapper";
import { AgentReportWrapper } from "../pages/report/ReportWrapper";
import { SearchWrapper } from "../pages/searchByUsername/SearchWrapper";
import { SubAgentWrapper } from "../pages/subagentlist/SubAgentWrapper";
import { TransactionWrapper } from "../pages/transaction/TransactionWrapper";
import { VipCommissionWrapper } from "../pages/vipCommission/VipCommissionWrapper";
import { VipEvaluateWrapper } from "../pages/vipEvaluate/VipEvaluateWrapper";
import { VipGameCommissionWrapper } from "../pages/vipGameCommission/VipGameCommissionWrapper";
import { VipHistoryWrapper } from "../pages/vipHistory/VipHistoryWrapper";
import { VipListWrapper } from "../pages/vipList/VipListWrapper";
import { VipVipCommissionWrapper } from "../pages/vipVipCommission/VipVipCommissionWrapper";
import { VipVipHistoryWrapper } from "../pages/vipVipHistory/VipVipHistoryWrapper";
import { getDateLocale } from "../utils/DateLocale";

const PrivateRoutes = () => {
  const intl = useIntl();
  let locale = intl.locale;
  registerLocale(locale, getDateLocale(locale));

  return (
    <>
      <Routes>
        <Route element={<MasterLayout />}>
          <Route path="home/*" element={<SearchWrapper />} />
          <Route path="dashboard/*" element={<DashbordWrapper />} />
          <Route path="changePassword/*" element={<ChangePasswordWrapper />} />
          <Route path="memberList/*" element={<MemberWrapper />} />
          <Route path="accountList/*" element={<AgentWrapper />} />
          <Route path="subAgentList/*" element={<SubAgentWrapper />} />
          <Route path="searchByUsername/*" element={<SearchWrapper />} />
          <Route path="projectCredit/*" element={<ProjectCreditWrapper />} />
          <Route
            path="platformSetting/*"
            element={<PlatformSettingWrapper />}
          />
          <Route path="agentReport/*" element={<AgentReportWrapper />} />
          <Route path="transaction/*" element={<TransactionWrapper />} />
          <Route path="memberRefund/*" element={<RefundNPromotionWrapper />} />
          <Route path="promotion/*" element={<PromotionWrapper />} />
          <Route path="messageBox/*" element={<MessageBoxWrapper />} />
          <Route path="vipList/*" element={<VipListWrapper />} />
          <Route path="vipCommission/*" element={<VipCommissionWrapper />} />
          <Route path="cashierSetting/*" element={<CashierSettingWrapper />} />
          <Route
            path="vipGameCommission/*"
            element={<VipGameCommissionWrapper />}
          />
          <Route path="vipHistory/*" element={<VipHistoryWrapper />} />
          <Route path="vipVipHistory/*" element={<VipVipHistoryWrapper />} />
          <Route path="vipEvaluate/*" element={<VipEvaluateWrapper />} />
          <Route
            path="vipVipCommission/*"
            element={<VipVipCommissionWrapper />}
          />
          <Route path="*" element={<Navigate to={"/home"} />} />
        </Route>
      </Routes>
    </>
  );
};

export { PrivateRoutes };
